module.exports = __webpack_public_path__ + "assets/bg-auth-overlay.025fcdc088bd832f702ff09a382adebc.png";